import { addKeyToAccount } from 'flow/transactions/account';
import React, { useState } from 'react';
import { Button, Modal, Form, ModalHeader, ModalBody, ModalFooter, FormGroup, InputGroup, InputGroupAddon, Input, InputGroupText, Label } from 'reactstrap';

function AddChildAccountModal({modal, toggle, args}) {
    const [publicKey, setPublicKey] = useState('')
    const [weight, setWeight] = useState('')
    const [signatureAlgorithm, setSignatureAlgorithm] = useState('')
    const [hashType, setHashType] = useState('')

    const hndleAddKeySubmit = async (event) => {
        event.preventDefault();
        console.log(publicKey)
        // await addKeyToAccount(publicKey.trim(), signatureAlgorithm, hashType, parseFloat(weight).toFixed(4))
        toggle()
      }

  return (
    <div>

      <Modal isOpen={modal} toggle={toggle} {...args}>
        <ModalHeader toggle={toggle}>Add New Key</ModalHeader>
        <ModalBody>
        <div className="text-center text-bold mb-4">
              <small>Add Child Account</small>
            </div>
            <Form role="form">

              <FormGroup>
                    <Label for="publickey">
                      Address
                    </Label>
                    <Input
                    id="publickey"
                    placeholder="Public Key"
                    type="text"
                    value={publicKey}
                    onChange={(e) => setPublicKey(e.target.value)}
                    />
                </FormGroup>
            </Form>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={hndleAddKeySubmit}>
            Send Request
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
}

export default AddChildAccountModal;